export default __webpack_public_path__ + "3c2724fd0f71ec744382a48a7f20b8f8.svg";